import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectPickTypeValue } from '../../services/pickTypes/selectors';

interface OwnProps {
    pickTypeId: number;
}

interface ConnectedProps {
    externalId?: string;
}

type Props = OwnProps & ConnectedProps;

export class PickTypeExternalIdValueComponent extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { externalId } = this.props;

        if (!externalId) {
            return null;
        }

        return externalId;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    externalId: makeSelectPickTypeValue('externalId')
});

export default connect(mapStateToProps)(PickTypeExternalIdValueComponent);
